import React, { useState, useEffect } from "react";
import { Input, Menu, Dropdown } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import getPlaces from "../../api/getPlaces";
import "./AddressInput.scss";

const AddressInput1 = ({ value, onChange, onSelect, ...props }) => {
  const [address, setAddress] = useState(value?.address ?? "");
  const [valid, setValid] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  const queryPlaces = async (query) => {
    try {
      const res = await getPlaces(query);
      setSuggestions(res.features);
    } catch (error) {
      console.error("Error querying places:", error);
    }
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setAddress(value);
    queryPlaces(value);
    setValid(false);
    onChange &&
      onChange({ address: value, latLng: { lat: null, lng: null } });
  };

  const handleSelectSuggestion = ({ place_name, center, context = [] }) => {
    const address = {
      address: place_name,
      latLng: {
        lng: center[0],
        lat: center[1],
      },
      countryCode: context[context.length - 1]?.short_code,
    };
    setAddress(place_name);
    setValid(true);
    onSelect && onSelect(address);
    setSuggestions([]);
  };

  useEffect(() => {
    setAddress(value?.address);
    if (value?.latLng?.lat && value?.latLng?.lng) setValid(true);
  }, [value]);

  const menu = suggestions.length ? (
    <Menu>
      {suggestions.map((suggestion, index) => {
        const className = suggestion.active
          ? "suggestion-item--active"
          : "suggestion-item";
        const style = suggestion.active
          ? {
              backgroundColor: "#fafafa",
              cursor: "pointer",
            }
          : {
              backgroundColor: "#ffffff",
              cursor: "pointer",
            };
        return (
          <Menu.Item key={index}>
            <div
              className={className}
              style={style}
              key={suggestion.place_name}
              onClick={() => handleSelectSuggestion(suggestion)}
            >
              <span>{suggestion.place_name}</span>
            </div>
          </Menu.Item>
        );
      })}
    </Menu>
  ) : (
    <></>
  );

  return (
    <Dropdown overlay={menu} placement="bottomLeft" visible={true}>
      <Input
        onChange={handleChange}
        value={address}
        autoComplete="no"
        suffix={
          valid && address ? (
            <CheckCircleFilled style={{ color: "#43C1C2" }} />
          ) : (
            ""
          )
        }
        {...props}
      />
    </Dropdown>
  );
};

export default AddressInput1;
